export interface TopicItem {
  id: number;
  name: string;
  count: string;
  hot: boolean;
}

export interface CardItem {
  id: number;
  title: string;
  desc: string;
  tag: string;
  image: string;
}

export interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

export interface CommentItem {
  id: number;
  name: string;
  avatar: string;
  content: string;
  time: string;
  likes: number;
}

export interface RankingItem {
  id: number;
  rank: number;
  title: string;
  category: string;
  views: string;
  change: 'up' | 'down' | 'same';
}

export interface FocusItem {
  id: number;
  title: string;
  desc: string;
  tag: string;
  image: string;
}

export interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  desc: string;
}

export interface IndexItem {
  id: number;
  title: string;
  count: string;
  icon: string;
}

export interface UpdateItem {
  id: number;
  title: string;
  time: string;
  category: string;
}

export interface MediaItem {
  id: number;
  title: string;
  duration: string;
  views: string;
  image: string;
}

export const topics: TopicItem[] = [
  { id: 1, name: 'NBA夏季联赛', count: '128.6万讨论', hot: true },
  { id: 2, name: 'LPL夏季赛', count: '96.3万讨论', hot: true },
  { id: 3, name: '中国好声音', count: '85.7万讨论', hot: true },
  { id: 4, name: '世界杯预选赛', count: '72.1万讨论', hot: false },
  { id: 5, name: '街舞大赛', count: '58.4万讨论', hot: false },
  { id: 6, name: '厨神争霸', count: '43.9万讨论', hot: false },
  { id: 7, name: '拳击之夜', count: '38.2万讨论', hot: false },
  { id: 8, name: '校园歌手大赛', count: '31.5万讨论', hot: false },
  { id: 9, name: '围棋名人战', count: '26.8万讨论', hot: false },
];

export const cards: CardItem[] = [
  {
    id: 1,
    title: 'NBA夏季联赛精彩集锦：新秀闪耀拉斯维加斯',
    desc: '2026年NBA夏季联赛火热进行中，多位新秀表现出色，精彩扣篮与三分远投引爆全场。',
    tag: '篮球赛事',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20shot%20with%20player%20dunking%20in%20a%20bright%20arena%2C%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20sports%20photography%20style%2C%20clean%20background%2C%20high%20energy%20atmosphere&width=800&height=500&seq=card-nba-01&orientation=landscape'
  },
  {
    id: 2,
    title: 'LPL夏季赛总决赛：巅峰对决一触即发',
    desc: '两支顶级战队会师总决赛，BO5大战谁能问鼎冠军？全方位解析双方实力对比与战术博弈。',
    tag: '电竞赛事',
    image: 'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20colorful%20stage%20lighting%20and%20massive%20screens%20displaying%20game%20action%2C%20crowded%20venue%20atmosphere%2C%20warm%20vibrant%20colors%2C%20professional%20gaming%20event%20photography%2C%20clean%20composition&width=800&height=500&seq=card-lol-02&orientation=landscape'
  },
  {
    id: 3,
    title: '中国好声音2026：哪位学员将夺得年度总冠军',
    desc: '四位导师战队终极对决，实力唱将云集。回顾本季最令人难忘的舞台表演与导师金句。',
    tag: '音乐综艺',
    image: 'https://readdy.ai/api/search-image?query=Singing%20competition%20stage%20with%20spotlight%20and%20microphone%2C%20dramatic%20theater%20lighting%2C%20warm%20golden%20and%20red%20stage%20design%2C%20professional%20performance%20photography%2C%20elegant%20composition%2C%20emotional%20atmosphere&width=800&height=500&seq=card-voice-03&orientation=landscape'
  },
  {
    id: 4,
    title: '世界杯预选赛亚洲区：国足关键战役回顾',
    desc: '亚洲区预选赛进入白热化阶段，回顾国足关键比赛精彩瞬间与出线形势深度分析。',
    tag: '足球赛事',
    image: 'https://readdy.ai/api/search-image?query=Soccer%20match%20action%20with%20players%20competing%20on%20green%20field%20under%20stadium%20lights%2C%20dramatic%20sports%20moment%2C%20warm%20evening%20atmosphere%2C%20professional%20sports%20photography%2C%20dynamic%20composition%2C%20clean%20background&width=800&height=500&seq=card-football-04&orientation=landscape'
  },
  {
    id: 5,
    title: '街舞大赛全国总决赛：Breaking巅峰之夜',
    desc: '全国顶尖街舞高手齐聚总决赛舞台，高难度动作轮番上演，点燃全场热烈气氛。',
    tag: '舞蹈竞技',
    image: 'https://readdy.ai/api/search-image?query=Street%20dance%20performance%20on%20stage%20with%20dynamic%20movement%20and%20colorful%20spotlights%2C%20urban%20style%20photography%2C%20warm%20amber%20and%20red%20lighting%2C%20high%20energy%20atmosphere%2C%20professional%20dance%20event%2C%20clean%20composition&width=800&height=500&seq=card-dance-05&orientation=landscape'
  },
  {
    id: 6,
    title: '厨神争霸总决赛：顶级大厨创意料理对决',
    desc: '全国厨神争霸赛进入终极对决，三位顶级大厨以创意料理争夺桂冠，色香味俱全。',
    tag: '美食竞技',
    image: 'https://readdy.ai/api/search-image?query=Professional%20cooking%20competition%20kitchen%20set%20with%20elegant%20plated%20dishes%2C%20warm%20golden%20lighting%2C%20gourmet%20food%20photography%20style%2C%20clean%20modern%20kitchen%20background%2C%20artistic%20presentation%2C%20warm%20atmosphere&width=800&height=500&seq=card-cook-06&orientation=landscape'
  },
];

export const faqs: FAQItem[] = [
  {
    id: 1,
    question: '每日大赛入口是什么平台？',
    answer: '每日大赛入口是一个专注于各类赛事视频的在线观看平台，汇集体育竞技、电子竞技、综艺选秀、才艺比赛等高质量赛事视频内容。我们每日更新最新最热的比赛回放、精彩集锦和全场录像，让您不错过任何一场精彩对决。平台支持高清流畅播放，无需下载即可在线观看。',
  },
  {
    id: 2,
    question: '每日大赛入口在线观看需要付费吗？',
    answer: '不需要。每日大赛入口提供完全免费的赛事视频在线观看服务，所有内容均可免费观看，无需会员注册，无隐藏收费。我们致力于为广大赛事爱好者打造一个便捷、免费的观赛平台，让每个人都能轻松畅享每日大赛的精彩内容。',
  },
  {
    id: 3,
    question: '每日大赛视频支持哪些设备观看？',
    answer: '每日大赛入口支持全平台观看，覆盖手机、平板、电脑等多种设备。无论您使用 iOS、Android、Windows 还是 Mac 系统，都可以通过浏览器直接访问每日大赛入口在线观看。我们针对移动端做了专门的适配优化，确保在手机上也能获得流畅清晰的观看体验。',
  },
  {
    id: 4,
    question: '如何快速找到想看的大赛视频？',
    answer: '您可以通过以下几种方式快速找到想看的内容：在首页热门话题区域查看当前最受关注的赛事话题；使用主题索引浏览不同分类的赛事合集；查看热门榜单了解当前热度最高的比赛视频；关注最新动态获取每日更新的赛事快讯。此外，您也可以使用站内搜索功能直接搜索感兴趣的赛事名称。',
  },
];

export const comments: CommentItem[] = [
  {
    id: 1,
    name: '篮球爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%20style%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20simple%20background%2C%20casual%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '每日大赛入口真的太方便了！NBA夏季联赛的回放特别全，画质也很清晰，每天下班都来看几场，强烈推荐给喜欢篮球的朋友们！',
    time: '2小时前',
    likes: 356,
  },
  {
    id: 2,
    name: '电竞迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%20style%2C%20modern%20casual%20look%2C%20warm%20lighting%2C%20friendly%20smile%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: 'LPL夏季赛的合集做得太棒了，每场关键比赛都有，而且更新速度特别快，比赛刚结束没多久就能看回放了。每日大赛入口是我每天必刷的网站！',
    time: '5小时前',
    likes: 289,
  },
  {
    id: 3,
    name: '音乐爱好者小张',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%20style%2C%20warm%20lighting%2C%20gentle%20smile%2C%20clean%20simple%20background%2C%20natural%20look&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '终于找到可以免费看好声音全集的地方了！之前在其他平台都要会员才能看，每日大赛入口免费观看太良心了，视频清晰度也很高。',
    time: '8小时前',
    likes: 203,
  },
  {
    id: 4,
    name: '足球铁粉老刘',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle%20aged%20man%20portrait%20avatar%20style%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20simple%20background%2C%20sports%20enthusiast&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '世界杯预选赛的集锦做得非常专业，每场关键比赛都有深度分析，每日大赛在线的内容质量越来越高了，已经成为我看球的首选平台。',
    time: '12小时前',
    likes: 178,
  },
  {
    id: 5,
    name: '综艺达人阿芳',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%20style%2C%20warm%20lighting%2C%20bright%20smile%2C%20clean%20simple%20background%2C%20fashionable%20casual&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '街舞大赛和厨神争霸都在这看的，每日大赛视频更新速度超快，而且没有广告干扰，观看体验特别好。已经安利给身边所有朋友了！',
    time: '1天前',
    likes: 156,
  },
];

export const rankings: RankingItem[] = [
  { id: 1, rank: 1, title: 'NBA夏季联赛：湖人vs勇士全场回放', category: '篮球', views: '256.8万', change: 'up' },
  { id: 2, rank: 2, title: 'LPL夏季赛总决赛BO5完整版', category: '电竞', views: '198.3万', change: 'up' },
  { id: 3, rank: 3, title: '中国好声音2026总决赛之夜', category: '音乐', views: '175.6万', change: 'same' },
  { id: 4, rank: 4, title: '世界杯预选赛：中国vs日本全场', category: '足球', views: '152.4万', change: 'down' },
  { id: 5, rank: 5, title: '街舞大赛全国总决赛Breaking战', category: '舞蹈', views: '128.9万', change: 'up' },
  { id: 6, rank: 6, title: '拳击之夜：重量级冠军争霸赛', category: '拳击', views: '98.7万', change: 'same' },
];

export const focusItems: FocusItem[] = [
  {
    id: 1,
    title: 'NBA夏季联赛专题',
    desc: '全程追踪2026年NBA夏季联赛，新秀首秀、精彩扣篮、绝杀瞬间一网打尽。',
    tag: '火热进行中',
    image: 'https://readdy.ai/api/search-image?query=Basketball%20arena%20with%20intense%20game%20action%2C%20players%20in%20motion%2C%20dramatic%20sports%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20professional%20sports%20photography%2C%20clean%20composition%2C%20energetic%20atmosphere&width=600&height=380&seq=focus-nba-01&orientation=landscape'
  },
  {
    id: 2,
    title: 'LPL夏季赛全记录',
    desc: '从常规赛到总决赛，LPL夏季赛每一场精彩对决，全方位深度赛事回顾。',
    tag: '赛季回顾',
    image: 'https://readdy.ai/api/search-image?query=Esports%20competition%20stage%20with%20vibrant%20colorful%20lighting%20and%20giant%20LED%20screens%2C%20professional%20gaming%20event%2C%20warm%20vibrant%20atmosphere%2C%20clean%20composition%2C%20modern%20arena&width=600&height=380&seq=focus-lol-02&orientation=landscape'
  },
  {
    id: 3,
    title: '好声音2026巅峰回顾',
    desc: '从盲选到总决赛，重温本季最打动人心的舞台表演与导师战队成长故事。',
    tag: '经典回放',
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20dramatic%20spotlight%20and%20microphone%20stand%2C%20warm%20golden%20red%20stage%20lighting%2C%20theater%20atmosphere%2C%20professional%20performance%20photography%2C%20elegant%20composition&width=600&height=380&seq=focus-voice-03&orientation=landscape'
  },
  {
    id: 4,
    title: '街舞大赛年度盛典',
    desc: 'Breaking、Popping、Locking各舞种顶尖高手对决，街舞文化的狂欢盛宴。',
    tag: '年度盛典',
    image: 'https://readdy.ai/api/search-image?query=Street%20dance%20battle%20on%20stage%20with%20dynamic%20movement%20and%20colorful%20spotlights%2C%20urban%20dance%20culture%2C%20warm%20amber%20lighting%2C%20high%20energy%20atmosphere%2C%20professional%20event%20photography&width=600&height=380&seq=focus-dance-04&orientation=landscape'
  },
  {
    id: 5,
    title: '世界杯亚洲区预选赛',
    desc: '全程关注亚洲区预选赛进程，国足关键战役回放与出线形势深度解读。',
    tag: '赛事追踪',
    image: 'https://readdy.ai/api/search-image?query=Soccer%20stadium%20with%20players%20on%20green%20field%20under%20bright%20lights%2C%20dramatic%20match%20moment%2C%20warm%20evening%20atmosphere%2C%20professional%20sports%20photography%2C%20clean%20dynamic%20composition&width=600&height=380&seq=focus-football-05&orientation=landscape'
  },
];

export const features: FeatureItem[] = [
  {
    id: 1,
    icon: 'ri-live-line',
    title: '每日更新',
    desc: '每日大赛入口坚持每日更新最新赛事视频，比赛结束后第一时间上线回放，让您不错过任何精彩内容。',
  },
  {
    id: 2,
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '所有每日大赛视频均支持高清播放，流畅无卡顿，为您带来媲美现场观赛的视觉体验。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '全平台支持',
    desc: '手机、平板、电脑多端适配，每日大赛在线观看随时随地，通勤路上也能畅享精彩赛事。',
  },
  {
    id: 4,
    icon: 'ri-vip-diamond-line',
    title: '完全免费',
    desc: '每日大赛免费观看所有内容，无需注册会员，无隐藏收费，纯粹为赛事爱好者打造的观赛平台。',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '安全流畅',
    desc: '每日大赛平台采用先进播放技术，播放过程安全流畅无广告干扰，专注为您提供优质的观赛体验。',
  },
];

export const indexItems: IndexItem[] = [
  { id: 1, title: '篮球赛事', count: '328个视频', icon: 'ri-basketball-line' },
  { id: 2, title: '足球赛事', count: '265个视频', icon: 'ri-football-line' },
  { id: 3, title: '电竞赛事', count: '412个视频', icon: 'ri-gamepad-line' },
  { id: 4, title: '音乐综艺', count: '189个视频', icon: 'ri-music-line' },
  { id: 5, title: '舞蹈竞技', count: '156个视频', icon: 'ri-run-line' },
  { id: 6, title: '拳击格斗', count: '134个视频', icon: 'ri-boxing-line' },
  { id: 7, title: '美食竞技', count: '98个视频', icon: 'ri-restaurant-line' },
  { id: 8, title: '棋牌对弈', count: '87个视频', icon: 'ri-puzzle-line' },
  { id: 9, title: '综合竞技', count: '201个视频', icon: 'ri-trophy-line' },
];

export const updates: UpdateItem[] = [
  { id: 1, title: 'NBA夏季联赛：新秀榜眼首秀砍下28分，率队逆转取胜', time: '30分钟前', category: '篮球' },
  { id: 2, title: 'LPL夏季赛总决赛门票3分钟售罄，线下观赛热度爆棚', time: '2小时前', category: '电竞' },
  { id: 3, title: '中国好声音总决赛收视率破纪录，全网热议冠军归属', time: '4小时前', category: '音乐' },
  { id: 4, title: '世界杯预选赛最新积分榜出炉，亚洲区出线形势渐明朗', time: '6小时前', category: '足球' },
  { id: 5, title: '街舞大赛Breaking项目裁判阵容公布，国际顶尖舞者加盟', time: '9小时前', category: '舞蹈' },
  { id: 6, title: '厨神争霸总冠军揭晓，创意融合料理征服评委味蕾', time: '12小时前', category: '美食' },
  { id: 7, title: '拳击之夜本周六开战，重量级拳王卫冕战备受瞩目', time: '16小时前', category: '拳击' },
  { id: 8, title: '围棋名人战决赛第三局：黑马选手再度爆冷击败卫冕冠军', time: '20小时前', category: '棋牌' },
];

export const mediaItems: MediaItem[] = [
  {
    id: 1,
    title: 'NBA夏季联赛十佳球：逆天暴扣与超远三分',
    duration: '05:28',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=Basketball%20highlight%20moment%20with%20player%20dunking%20in%20arena%2C%20dramatic%20sports%20lighting%2C%20warm%20golden%20tones%2C%20professional%20sports%20photography%2C%20clean%20composition%2C%20video%20thumbnail%20style&width=640&height=360&seq=media-nba-01&orientation=landscape'
  },
  {
    id: 2,
    title: 'LPL总决赛决胜局：史诗级团战逆转',
    duration: '08:15',
    views: '96.3万',
    image: 'https://readdy.ai/api/search-image?query=Esports%20game%20action%20on%20giant%20screen%20with%20colorful%20visual%20effects%2C%20professional%20gaming%20event%2C%20warm%20vibrant%20lighting%2C%20clean%20composition%2C%20video%20thumbnail%20style%2C%20dynamic&width=640&height=360&seq=media-lol-02&orientation=landscape'
  },
  {
    id: 3,
    title: '好声音总决赛：冠军学员夺冠曲目全纪录',
    duration: '12:40',
    views: '85.7万',
    image: 'https://readdy.ai/api/search-image?query=Singer%20on%20stage%20with%20spotlight%20and%20microphone%2C%20dramatic%20golden%20stage%20lighting%2C%20warm%20theater%20atmosphere%2C%20professional%20performance%20photography%2C%20clean%20composition%2C%20video%20thumbnail&width=640&height=360&seq=media-voice-03&orientation=landscape'
  },
  {
    id: 4,
    title: '世界杯预选赛：国足精彩配合破门集锦',
    duration: '06:52',
    views: '72.1万',
    image: 'https://readdy.ai/api/search-image?query=Soccer%20goal%20celebration%20moment%20on%20green%20field%2C%20players%20celebrating%2C%20stadium%20lights%2C%20warm%20evening%20atmosphere%2C%20professional%20sports%20photography%2C%20clean%20composition%2C%20video%20thumbnail&width=640&height=360&seq=media-football-04&orientation=landscape'
  },
  {
    id: 5,
    title: '街舞大赛Breaking：高难度动作燃爆全场',
    duration: '04:36',
    views: '58.4万',
    image: 'https://readdy.ai/api/search-image?query=Breakdancer%20performing%20dynamic%20move%20on%20stage%20with%20colorful%20spotlights%2C%20urban%20dance%20style%2C%20warm%20amber%20lighting%2C%20high%20energy%2C%20clean%20composition%2C%20video%20thumbnail%20style&width=640&height=360&seq=media-dance-05&orientation=landscape'
  },
];